import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import { HotkeyHint } from '@game-libs/exc-libs';

type ButtonProps = {
  id?: string;
  labelId?: string;
  onClick: (action: { type: string }) => void;
  width?: number;
  height?: number;
  checked?: boolean;
  disabled?: boolean;
  hotkey?: string | number;
  /** For e2e tests */
  'data-testid'?: string;
};

export const GameButton = ({
  id,
  labelId,
  onClick,
  width = 32,
  height = 32,
  checked,
  disabled = false,
  hotkey,
  'data-testid': dataTestId,
}: ButtonProps) => {
  const { t } = useTranslation('settings');

  return (
    <div
      className={`${styles.gameButton} ${disabled ? styles.disabled : ''}`}
      onClick={disabled ? undefined : onClick}
      data-testid={dataTestId}
    >
      {labelId && <div>{t(labelId)}</div>}
      <button
        style={
          {
            '--background': id ? `url('../ui/buttons/${id}.png')` : 'none',
            width: `${width}px`,
            height: `${height}px`,
          } as React.CSSProperties
        }
        className={`${styles.button} ${checked ? styles.checked : ''}`}
      ></button>
      {hotkey && <HotkeyHint hint={hotkey} />}
    </div>
  );
};
